/**
 * 将子元素滚动至可视区域
 *
 * @param scrollViewEl 滚动容器
 * @param index 子元素位置
 * @param behavior 滚动行为
 */
export function scrollToVisible(scrollViewEl, index, behavior) {
  var _a, _b;
  var fristEl = scrollViewEl.children[0];
  var targetEl = scrollViewEl.children[index];
  if (targetEl) {
    var prevWidth = (_b = (_a = scrollViewEl.children[index - 1]) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
    var prevOffset = prevWidth / 3 * 2; // 使前元素的三分之二处于可视区域
    var offsetLeft =
    // @ts-ignore
    targetEl.offsetLeft - fristEl.offsetLeft - prevOffset;
    scrollViewEl.scrollTo({
      left: offsetLeft,
      behavior: behavior
    });
  }
}